import { globalFontStyle } from '../assets/Font/FontFamily';

const baseColors = {
  primary: '#0A57FF',
  secondary: '#AA00FF',
  success: '#00AA51',
  error: '#FF3739',
  warning: '#FF7731',
  info: '#0A57FF',
  background: {
    primary: '#FFFFFF',
    secondary: '#F8F8F8',
    tertiary: '#F2F2F2',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.9)',
    secondary: '#777777',
    disabled: 'rgba(0, 0, 0, 0.3)',
  },
  border: 'rgb(224, 224, 224)',
};

const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

const typography = {
  ...globalFontStyle,
  h1: {
    fontSize: 24,
    lineHeight: 32,
    fontWeight: 'bold',
  },
  h2: {
    fontSize: 20,
    lineHeight: 28,
    fontWeight: 'bold',
  },
  body1: {
    fontSize: 16,
    lineHeight: 24,
  },
  body2: {
    fontSize: 14,
    lineHeight: 20,
  },
  caption: {
    fontSize: 12,
    lineHeight: 16,
  },
};

const shadows = {
  sm: {
    shadowColor: 'rgba(0, 0, 0, 0.15)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
  },
  md: {
    shadowColor: 'rgba(0, 0, 0, 0.15)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
};

const defaultTheme = {
  colors: baseColors,
  spacing,
  typography,
  shadows,
};

// Partner-specific theme overrides
const partnerThemes = {
  partner1: {
    colors: {
      ...baseColors,
      primary: '#5037BF',
      secondary: '#FCBF39',
    },
  },
  // Add more partner themes as needed
};

export const getTheme = (partner) => {
  if (partner && partnerThemes[partner]) {
    return {
      ...defaultTheme,
      ...partnerThemes[partner],
    };
  }
  return defaultTheme;
};

export default defaultTheme; 